import {
  ChangeEvent,
  Dispatch,
  SetStateAction,
  FocusEvent,
  MouseEvent,
  DetailedHTMLProps,
  TextareaHTMLAttributes,
  InputHTMLAttributes,
} from 'react';

import { FeedbackFormStateValue } from 'constants/enums';
import {
  Block,
  Link,
  Text,
} from 'src/__generated__/graphqlTypes';
import { IdNameType, ValidationAndValue } from 'types/objectTypes';

export interface FeedbackFormInterfaceStateValues {
  [FeedbackFormStateValue.NAME]: ValidationAndValue<string>;
  [FeedbackFormStateValue.EMAIL]: ValidationAndValue<string>;
  [FeedbackFormStateValue.PHONE_NUMBER]: ValidationAndValue<string>;
  [FeedbackFormStateValue.COUNTRY]: ValidationAndValue<string>;
  [FeedbackFormStateValue.REQUEST_TYPE]: ValidationAndValue<{
    id: string;
    name: string;
  }>;
  [FeedbackFormStateValue.MESSAGE]: ValidationAndValue<string>;
}

export interface FeedbackFormInterfaceProps {
  feedbackForm: Block;
  button: Link;
  title: string;
  modal: Block;
  isModalVisible: boolean;
  countries: Array<Text>;
  inputValues: FeedbackFormInterfaceStateValues;
  requestTypeOptions: Array<Text>;
  setInputValues: Dispatch<SetStateAction<FeedbackFormInterfaceStateValues>>;
  searchInCountries: (text: string) => void;
  handleSubmitForm: (values: FeedbackFormInterfaceStateValues) => void;
  closeModal: () => void;
  fetchCountries: () => void;
}

export interface FeedbackFormSelectInterface {
  title: string;
  name?: FeedbackFormStateValue;
  selectOptions: Array<Text>;
  className?: string;
  isInput?: boolean;
  inputData: ValidationAndValue<IdNameType<string> | string>;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur: (e?: FocusEvent<HTMLUListElement>) => void;
  setInputValue: (item: Text | any) => void;
  onClick?: (e: MouseEvent<HTMLButtonElement | HTMLInputElement>) => void;
}

export enum FeedbackFormContainerSlug {
  NAME_INPUT = 'nameInput',
  EMAIL_INPUT = 'emailInput',
  PHONE_NUMBER_INPUT = 'phoneNumberInput',
  COUNTRY_INPUT = 'countryInput',
  REQUEST_TYPE_INPUT = 'requestTypeInput',
  MESSAGE_INPUT = 'messageInput',
  MODAL = 'modal',
}

export interface ZendeskModalInterface {
  modal: Block;
  isModalVisible?: boolean;
  closeModal: () => void;
}

export type InputValidation = Omit<
ValidationAndValue<any>,
'value' | 'alerts' | 'sysId'
> & {
  validation: boolean;
};

export type ErrorHandler = (
  item: ValidationAndValue<string | IdNameType<string>>,
  pattern?: RegExp | string | null,
  itemValue?: string | IdNameType<string>
) => InputValidation;

export interface FeedbackFormInputCommonInterface {
  isArea?: boolean;
  inputData: ValidationAndValue<IdNameType<string> | string>;
}

export interface FeedbackFormInputInterface
  extends DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
  >,
  FeedbackFormInputCommonInterface {}

export interface FeedbackFormTextareaInterface
  extends DetailedHTMLProps<
  TextareaHTMLAttributes<HTMLTextAreaElement>,
  HTMLTextAreaElement
  >,
  FeedbackFormInputCommonInterface {}

export interface CommonInputInterface
  extends DetailedHTMLProps<
  TextareaHTMLAttributes<HTMLTextAreaElement>,
  HTMLTextAreaElement
  >,
  FeedbackFormInputCommonInterface {}

export interface FeedbackFormContainerInterface {
  feedbackForm: Block;
}
